import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ChatbotRoutingModule } from './chatbot-routing.module';

import { ChatbotButtonComponent } from './components/chatbot-button/chatbot-button.component';
import { ChatbotPanelComponent } from './components/chatbot-panel/chatbot-panel.component';
import { ChatbotMessageComponent } from './components/chatbot-message/chatbot-message.component';
import { SessionListComponent } from './components/session-list/session-list.component';
import { BoldMarkdownPipe } from './pipes/bold-markdown.pipe';

@NgModule({
  declarations: [
    ChatbotButtonComponent,
    ChatbotPanelComponent,
    ChatbotMessageComponent,
    SessionListComponent,
    BoldMarkdownPipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ChatbotRoutingModule,
  ],
  exports: [
    ChatbotButtonComponent,
    ChatbotMessageComponent,
  ]
})
/**
 * Módulo del chatbot asistente.
 *
 * Agrupa los componentes del chatbot (botón flotante, panel deslizable,
 * mensaje individual y lista de sesiones) junto con el pipe de markdown,
 * y expone el botón y el mensaje para su uso en otros módulos.
 */
export class ChatbotModule { }
